import qs from "qs";

import { callGet, wrapCall } from "./helpers";

//* ~~~~~~ ACTIVITY ROUTES ~~~~~~

// Get activities for a task
export const getTaskActivities = async ({
  id,
  limit = 100,
  after = null,
}: {
  id: string;
  limit?: number;
  after: string | null;
}) => {
  const query = qs.stringify(
    { type: "task", id, limit, after: after ?? undefined },
    { addQueryPrefix: true },
  );

  return (await wrapCall({
    method: callGet,
    uri: `/activities${query}`,
    noData: true,
  })) as WithTokenPagination<TaskActivityResponse[]>;
};

// Get activities for a task
export const getUserActivities = async ({
  id,
  limit = 100,
  after = null,
}: {
  id: string;
  limit?: number;
  after: string | null;
}) => {
  const query = qs.stringify(
    { type: "user", id, limit, after: after ?? undefined },
    { addQueryPrefix: true },
  );

  return (await wrapCall({
    method: callGet,
    uri: `/activities${query}`,
    noData: true,
  })) as WithTokenPagination<UserActivityResponse[]>;
};
